export function validateHouseNumber(value: any): string | undefined {
    if (!value || value.trim() === '') {
        return 'House number is required'
    }

    if (!/^[a-zA-Z0-9]{1,4}$/.test(value)) {
        return 'House Number must be alphanumeric and max 4 characters'
    }

    return undefined
}